"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var SearchActionLink = function SearchActionLink(_ref) {
  var highlightedIndex = _ref.highlightedIndex,
      previousResultsCount = _ref.previousResultsCount,
      href = _ref.href,
      icon = _ref.icon,
      children = _ref.children,
      trackType = _ref.trackType,
      elementName = _ref.elementName;
  return (0, _preact.h)("a", {
    className: "link algolia-search__action",
    style: {
      backgroundColor: highlightedIndex === previousResultsCount ? '#F2F2F2' : ''
    },
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    "data-track-type": trackType,
    "data-element-name": elementName
  }, (0, _preact.h)("span", {
    className: "algolia-search__action-icon",
    style: {
      color: 'currentColor'
    }
  }, icon), (0, _preact.h)("span", {
    className: "algolia-search__action-link"
  }, children));
};

var _default = SearchActionLink;
exports.default = _default;